import emailjs, { init } from "emailjs-com";
import { set, template } from "lodash-es";

window.dataLayer = window.dataLayer || [];
const formEl = document.getElementById("formEl");
const formPrivacyCheckboxEl = document.getElementById("privacidad");
const formSubmitButton = document.getElementById("form-submit");
const policyAccept = document.getElementById("policy-accept");
const successMessage = document.getElementById("success-message");

init("user_fovtOnGpVLiQIamFXixol");

function gtag() {
  dataLayer.push(arguments);
}

function sendTagEvent() {
  gtag("event", "conversion", {
    send_to: "AW-653134868/cWBVCL-utMwBEJSYuLcC",
    // send_page_view: false,
    // conversion_linker: false,
  });

  gtag("event", "enviado", {
    event_category: "formulario",
    event_label: "formulariocontacto",
    // send_to: 'AW-653134868/cWBVCL-utMwBEJSYuLcC',
    // send_page_view: false,
    // conversion_linker: false,
  });
}

/**
 * Enables or disables the submit button.
 *
 * @param {boolean} enable - Indicates whether the button should be disabled.
 * @throws {TypeError} If the 'disable' argument is not a boolean.
 */
function enableSubmitButton(enable) {
  if (typeof enable !== "boolean")
    throw new TypeError("The disable argument must be a boolean");

  if (enable) {
    formSubmitButton.disabled = false;
    formSubmitButton.classList.remove("disabled");
  } else {
    formSubmitButton.disabled = true;
    formSubmitButton.classList.add("disabled");
  }
}

async function sendEmail(templateParams) {
  return new Promise((resolve, reject) => {
    emailjs
      .send(
        "service_1blijo6",
        "template_631z02j",
        templateParams,
        "user_fovtOnGpVLiQIamFXixol"
      )
      .then((response) => {
        resolve();
      })
      .catch((error) => {
        reject(new Error(error));
      });
  });
}

//*ACTIONS
formEl.addEventListener("submit", onSubmitForm);
formPrivacyCheckboxEl.addEventListener("click", onPrivacyCheckboxClick);

function onPrivacyCheckboxClick() {
  if (formPrivacyCheckboxEl.checked) {
    enableSubmitButton(true);
    policyAccept.classList.add("d-none");
  } else {
    enableSubmitButton(false);
    policyAccept.classList.remove("d-none");
  }
};

function onSubmitForm(event) {
  event.preventDefault();

  if (!formPrivacyCheckboxEl.checked) {
    if (policyAccept.classList.contains("d-none"))
      policyAccept.classList.remove("d-none");
    return;
  }

  sendTagEvent();

  const templateParams = Array.from(event.target).reduce((acc, input) => {
    if (input.id === "form-submit") return acc;
    return {
      ...acc,
      [input.id]: input.value,
    };
  }, {});

  templateParams["sid"] = sessionStorage.getItem("sid");

  enableSubmitButton(false);
  formSubmitButton.innerText = "Enviando...";

  sendEmail(templateParams)
    .then(() => {
      formSubmitButton.innerText = "¡Enviado!";
      if(successMessage) successMessage.classList.remove("d-none");
    })
    .catch((error) => {
      console.error(error);
      formSubmitButton.innerText = "¡Prueba de nuevo!";
      enableSubmitButton(true);
    });

  return false;
}
